<template>
  <div
    class="p-3 bg-white card multisteps-form__panel border-radius-xl"
    data-animation="FadeIn"
  >
    <h5 class="font-weight-bolder">Operações</h5>
    <div class="multisteps-form__content">
      <div class="mt-4 button-row d-flex col-12">
        <argon-button
          type="button"
          color="dark"
          variant="gradient"
          class="mb-0 ms-auto js-btn-next"
          title="Next"
          @click="$parent.nextStep"
          >Próximo</argon-button
        >
      </div>
      <div class="table-responsive p-0">
        <table class="table align-items-center mb-0">
          <thead>
            <tr>
              <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Operação</th>
              <th class="text-center text-uppercase text-secondary text-xxs font-weight-bolder opacity-7">Status</th>
            </tr>
          </thead>
          <tbody>

            <tr v-for="produto in operacoes">
              <td>
                <div class="d-flex px-2 py-1">
                  <div class="d-flex flex-column justify-content-center">
                    <h6 class="mb-0 text-sm">{{produto.name}}</h6>
                    <p class="text-xs text-secondary mb-0">{{produto.brand}}</p>
                  </div>
                </div>
              </td>
              <td class="align-middle text-center text-sm">
                <div class="form-check form-switch">
                  <input class="form-check-input" type="checkbox" id="flexSwitchCheckDefault" v-model="produto.ativo">
                  <label class="form-check-label" for="flexSwitchCheckDefault">
                    <span 
                      class="badge badge-sm"
                      :class="{'bg-success': produto.ativo, 'bg-danger': !produto.ativo}"
                    >
                      {{ produto.ativo ? 'Ativo' : 'Inativo' }}
                    </span>
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>    
    </div>
  </div>
</template>

<script>
import Quill from "quill";
import Choices from "choices.js";
import ArgonButton from "@/components/ArgonButton.vue";

export default {
  name: "ProductInfo",
  components: {
    ArgonButton,
  },
  props: {
    operacoes: {
      type: Array,
      default: () => {
        [];
      },
    },
  },
  mounted() {


  },
};
</script>
